import { render, staticRenderFns } from "./advancedSlice.vue?vue&type=template&id=be941c86&scoped=true&"
import script from "./advancedSlice.vue?vue&type=script&lang=js&"
export * from "./advancedSlice.vue?vue&type=script&lang=js&"
import style0 from "./advancedSlice.vue?vue&type=style&index=0&id=be941c86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be941c86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build-wheel.7Tky5E/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be941c86')) {
      api.createRecord('be941c86', component.options)
    } else {
      api.reload('be941c86', component.options)
    }
    module.hot.accept("./advancedSlice.vue?vue&type=template&id=be941c86&scoped=true&", function () {
      api.rerender('be941c86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/advancedSlice.vue"
export default component.exports